const siteFooterTheme = {
    footer: {
        defaultFooter: {
            backgroundStart: 'transparent',
            backgroundEnd: 'transparent',
        },
    },
};
export default siteFooterTheme;
